module.exports = __webpack_public_path__ + "img/zoo1.805ebc4a.jpg";